import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useElementHover, useElementSize, useEventListener, useMouseInElement } from '@vueuse/core';
import { isNumber } from 'lodash-es';
import { FileType } from '~/core/enums';
import EditorTemplate from './EditorTemplate.vue';
import ActionBtn from './ActionBtn.vue';
var ADDITIONAL_LINE_WIDTH = 20;
export default defineComponent({
  name: 'ImageDrawer',
  components: {
    EditorTemplate: EditorTemplate,
    ActionBtn: ActionBtn
  },
  props: {
    src: {
      type: String,
      required: true
    },
    lineColor: {
      type: String,
      default: '#FFFFFF'
    },
    /**
     * Ширина линии рисования 1 - 100
     * */
    lineWidth: {
      type: Number,
      default: 50,
      validator: function validator(v) {
        return isNumber(v) && v >= 1 && v <= 100;
      }
    },
    outputFileName: {
      type: String,
      default: 'Изображение'
    }
  },
  emits: ['update:line-width', 'save'],
  setup: function setup(props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var img = ref(null);
    var rootElement = ref(null);
    var canvas = ref(null);
    var widthSlider = ref(null);
    var innerLineWidth = ref(50);
    var isPressed = ref(false);
    var isSliderActive = ref(false);
    var history = ref([[]]);
    var _useNuxtApp = useNuxtApp(),
      $device = _useNuxtApp.$device;
    var _useElementSize = useElementSize(rootElement),
      width = _useElementSize.width,
      height = _useElementSize.height;
    var _useMouseInElement = useMouseInElement(canvas, {
        handleOutside: false
      }),
      elementX = _useMouseInElement.elementX,
      elementY = _useMouseInElement.elementY,
      isOutside = _useMouseInElement.isOutside;
    var isSliderHovered = useElementHover(widthSlider);
    var contentStyle = ref({
      top: '0',
      left: '0',
      width: 0,
      height: 0
    });
    var ctx = computed(function () {
      var _canvas$value;
      return (_canvas$value = canvas.value) === null || _canvas$value === void 0 ? void 0 : _canvas$value.getContext('2d');
    });
    var formattedLineWidth = computed(function () {
      return Math.min(width.value, height.value) * 0.00075 * (innerLineWidth.value + ADDITIONAL_LINE_WIDTH);
    });
    var cursorStyle = computed(function () {
      return {
        display: isOutside.value || isSliderHovered.value ? 'none' : 'block',
        background: props.lineColor,
        top: "".concat(elementY.value - formattedLineWidth.value / 2, "px"),
        left: "".concat(elementX.value - formattedLineWidth.value / 2, "px"),
        width: "".concat(formattedLineWidth.value, "px"),
        height: "".concat(formattedLineWidth.value, "px")
      };
    });
    watch(function () {
      return props.lineWidth;
    }, function (val) {
      innerLineWidth.value = val;
    }, {
      immediate: true
    });
    watch(innerLineWidth, function (val) {
      if (val !== props.lineWidth) {
        emit('update:line-width', val);
      }
    });
    watch(isPressed, function (val) {
      if (!isOutside.value && !val) {
        history.value.push([]);
      }
    });
    watch([elementX, elementY], function (_ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 2),
        x = _ref4[0],
        y = _ref4[1];
      var _ref5 = _slicedToArray(_ref3, 2),
        prevX = _ref5[0],
        prevY = _ref5[1];
      if (!isOutside.value && isPressed.value) {
        var newLine = {
          start: {
            x: prevX,
            y: prevY
          },
          end: {
            x: x,
            y: y
          },
          width: formattedLineWidth.value
        };
        history.value[history.value.length - 1].push(newLine);
        drawLines(ctx.value, [newLine]);
      }
    });
    onBeforeMount(function () {
      if ($device.isMobileOrTablet) {
        useEventListener('touchstart', handleStartDrawing);
        useEventListener('touchend', function () {
          isPressed.value = false;
        });
        return;
      }
      useEventListener('mousedown', handleStartDrawing);
      useEventListener('mouseup', function () {
        isPressed.value = false;
      });
    });
    function handleImageLoad() {
      return _handleImageLoad.apply(this, arguments);
    }
    function _handleImageLoad() {
      _handleImageLoad = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return nextTick();
            case 2:
              resizeContent();
              watch([width, height], function () {
                resizeContent();
              });
              watch([function () {
                return contentStyle.value.width;
              }, function () {
                return contentStyle.value.height;
              }], /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref7, _ref8) {
                  var _ref10, width, height, _ref11, prevWidth, prevHeight, widthDeltaMultiplier, heightDeltaMultiplier;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _ref10 = _slicedToArray(_ref7, 2), width = _ref10[0], height = _ref10[1];
                        _ref11 = _slicedToArray(_ref8, 2), prevWidth = _ref11[0], prevHeight = _ref11[1];
                        widthDeltaMultiplier = width / prevWidth;
                        heightDeltaMultiplier = height / prevHeight;
                        history.value = history.value.map(function (lines) {
                          return lines.map(function (_ref12) {
                            var start = _ref12.start,
                              end = _ref12.end,
                              width = _ref12.width;
                            return {
                              start: {
                                x: start.x * widthDeltaMultiplier,
                                y: start.y * heightDeltaMultiplier
                              },
                              end: {
                                x: end.x * widthDeltaMultiplier,
                                y: end.y * heightDeltaMultiplier
                              },
                              width: width * widthDeltaMultiplier
                            };
                          });
                        });
                        _context.next = 7;
                        return nextTick();
                      case 7:
                        drawLines(ctx.value, history.value.flat());
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref9.apply(this, arguments);
                };
              }());
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _handleImageLoad.apply(this, arguments);
    }
    function resizeContent() {
      if (!img.value) {
        return;
      }
      var targetWidth = 0;
      var targetHeight = 0;
      var targetBound = 'width';
      if (img.value.naturalWidth < img.value.naturalHeight) {
        targetBound = 'height';
      }
      if (targetBound === 'width') {
        targetWidth = width.value;
        targetHeight = width.value / img.value.naturalWidth * img.value.naturalHeight;
        if (targetHeight > height.value) {
          targetWidth = targetWidth * (height.value / targetHeight);
          targetHeight = height.value;
        }
      }
      if (targetBound === 'height') {
        targetWidth = height.value / img.value.naturalHeight * img.value.naturalWidth;
        targetHeight = height.value;
        if (targetWidth > width.value) {
          targetHeight = targetHeight * (width.value / targetWidth);
          targetWidth = width.value;
        }
      }
      contentStyle.value = {
        top: "".concat((height.value - targetHeight) / 2, "px"),
        left: "".concat((width.value - targetWidth) / 2, "px"),
        width: targetWidth,
        height: targetHeight
      };
    }
    function handleStartDrawing(ev) {
      isPressed.value = ev.target === canvas.value;
      if (!isPressed.value) {
        return;
      }
      isSliderActive.value = false;
      var newLine = {
        start: {
          x: elementX.value,
          y: elementY.value
        },
        end: {
          x: elementX.value,
          y: elementY.value
        },
        width: formattedLineWidth.value
      };
      history.value[history.value.length - 1].push(newLine);
      drawLines(ctx.value, [newLine]);
    }
    function drawLines(ctx, lines) {
      lines.forEach(function (_ref6) {
        var start = _ref6.start,
          end = _ref6.end,
          width = _ref6.width;
        ctx.beginPath();
        ctx.lineWidth = width;
        ctx.lineCap = 'round';
        ctx.strokeStyle = props.lineColor;
        ctx.moveTo(start.x, start.y);
        ctx.lineTo(end.x, end.y);
        ctx.stroke();
      });
    }
    function clearCanvas() {
      if (!ctx.value || !canvas.value) {
        return;
      }
      ctx.value.clearRect(0, 0, canvas.value.width, canvas.value.height);
    }
    function undo() {
      if (!history.value[history.value.length - 1].length) {
        history.value.pop();
      }
      history.value.splice(history.value.length - 1, 1, []);
      clearCanvas();
      drawLines(ctx.value, history.value.flat());
    }
    function save() {
      return _save.apply(this, arguments);
    }
    function _save() {
      _save = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var fileName,
          saverCanvas,
          saverCanvasCtx,
          widthDeltaMultiplier,
          heightDeltaMultiplier,
          realSizeImageLines,
          promise,
          file,
          _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              fileName = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'Изображение';
              if (img.value) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              saverCanvas = document.createElement('canvas');
              saverCanvas.width = img.value.naturalWidth;
              saverCanvas.height = img.value.naturalHeight;
              saverCanvasCtx = saverCanvas.getContext('2d');
              widthDeltaMultiplier = img.value.naturalWidth / contentStyle.value.width;
              heightDeltaMultiplier = img.value.naturalHeight / contentStyle.value.height;
              realSizeImageLines = history.value.flat().map(function (_ref13) {
                var start = _ref13.start,
                  end = _ref13.end,
                  width = _ref13.width;
                return {
                  start: {
                    x: start.x * widthDeltaMultiplier,
                    y: start.y * heightDeltaMultiplier
                  },
                  end: {
                    x: end.x * widthDeltaMultiplier,
                    y: end.y * heightDeltaMultiplier
                  },
                  width: width * widthDeltaMultiplier
                };
              });
              saverCanvasCtx.drawImage(img.value, 0, 0);
              drawLines(saverCanvasCtx, realSizeImageLines);
              promise = new Promise(function (resolve) {
                saverCanvas.toBlob(function (blob) {
                  resolve(new File([blob], fileName, {
                    type: FileType.Jpeg
                  }));
                });
              });
              _context3.next = 15;
              return promise;
            case 15:
              file = _context3.sent;
              emit('save', file);
              return _context3.abrupt("return", file);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _save.apply(this, arguments);
    }
    expose({
      undo: undo,
      save: save
    });
    return {
      img: img,
      contentStyle: contentStyle,
      cursorStyle: cursorStyle,
      rootElement: rootElement,
      widthSlider: widthSlider,
      isSliderActive: isSliderActive,
      undo: undo,
      save: save,
      handleImageLoad: handleImageLoad,
      innerLineWidth: innerLineWidth,
      width: width,
      height: height,
      canvas: canvas,
      history: history // Для тестирования
    };
  }
});